import axios from 'axios'
import * as rax from 'retry-axios'
import {WrappedExceptionError} from '@/error/WrappedExceptionError'
import {AjaxExceptionError} from '@/error/AjaxExceptionError'

const DEBUG = parseInt(process.env.VUE_APP_DEBUG)
const debug = msg => {
  if (DEBUG === 1)
    console.log(msg)
}

export default class {
  constructor(resource) {
    this.resource = resource
  }

  async request(token, type, options) {
    try {
      const $http = axios.create({
        baseURL: process.env.VUE_APP_RESTAPI_BASEURL,
        timeout: 60000,
      })
      // retry policty
      $http.defaults.raxConfig = {
        // If you are using a non static instance of Axios you need
        // to pass that instance here (const $http = axios.create())
        instance: $http,
        // Retry 3 times on requests that return a response (500, etc) before giving up.  Defaults to 3.
        retry: 5,
        // Retry twice on errors that don't return a response (ENOTFOUND, ETIMEDOUT, etc).
        noResponseRetries: 2,
        // Milliseconds to delay at first.  Defaults to 100. Only considered when backoffType is 'static' 
        retryDelay: 1000,
        // HTTP methods to automatically retry.  Defaults to:
        // ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT']
        httpMethodsToRetry: ['GET', 'HEAD', 'OPTIONS', 'DELETE', 'PUT'],
        // The response status codes to retry.  Supports a double
        // array with a list of ranges.  Defaults to:
        // [[100, 199], [429, 429], [500, 599]]
        statusCodesToRetry: [[100, 199], [404, 404], [429, 429], [500, 599]],
        // You can set the backoff type.
        // options are 'exponential' (default), 'static' or 'linear'
        backoffType: 'static',
        // You can detect when a retry is happening, and figure out how many
        // retry attempts have been made
        onRetryAttempt: err => {
          const cfg = rax.getConfig(err)
          debug(`Axios Retry attempt #${cfg.currentRetryAttempt}`)
        },
      }
      const interceptorId = rax.attach($http)

      $http.defaults.headers.common['Authorization'] = token
      const path = options.path ? this.resource + options.path : this.resource
      const response = type === 'delete'
        ? await $http[type](path, {data: options.data})
        : await $http[type](path, options.data)
      return response.data
    } catch (error) {
      debug(error)
      if(error.isAxiosError) throw new AjaxExceptionError(error, options.action)
      throw new WrappedExceptionError(error, options.action)
    }
  }

  async post(token, options = {path: '', data: {}, action: null}) {
    return await this.request(token, 'post', options)
  }

  async get(token, options = {path: '', data: {}, action: null}) {
    return await this.request(token, 'get', options)
  }

  async put(token, options = {path: '', data: {}, action: null}) {
    return await this.request(token, 'put', options)
  }

  async patch(token, options = {path: '', data: {}, action: null}) {
    return await this.request(token, 'patch', options)
  }

  async delete(token, options = {path: '', data: {}, action: null}) {
    return await this.request(token, 'delete', options)
  }

  async downLoadFile(token, options = {path: '', data: {}, action: null, 'Content-Type': null }) {
    return await this.downLoadRequest(token, 'get', options)
  }

  async downLoadRequest(token, type, options) {
    try {
      const $http = axios.create({
        baseURL: process.env.VUE_APP_RESTAPI_BASEURL,
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': options['Content-Type']
        }
      })
      $http.defaults.headers.common['Authorization'] = token
      $http.defaults.timeout = process.env.VUE_APP_DOWNLOAD_REQUEST_TIMEOUT
      const path = options.path ? this.resource + options.path : this.resource
      const response = await $http[type](path, options.data)

      return response.data
    } catch (error) {
      if(error.isAxiosError)  throw new AjaxExceptionError(error,options.action)
      throw new WrappedExceptionError(error,options.action)
    }
  }

  async safieRequest(type, path , options) {
    console.log('safieRequest start')
    try {
      const $http = axios.create(
        {
          baseURL: 'https://openapi.safie.link',
        }
      )
      const response = await $http[type]('https://openapi.safie.link' + path, options.data)
      return response.data
    } catch (error) {
      if(error.isAxiosError)  throw new AjaxExceptionError(error,options.action)
      throw new WrappedExceptionError(error,options.action)
    }
  }

}
